const categories = {
  en: {
    categories: {
      labels: {
        name: {
          title: "Name"
        },
        category_type: {
          title: "Category Type"
        },
        required: {
          title: "Required"
        },
        cardinality: {
          title: "Cardinality"
        },
        record_tone: {
          title: "Record Tone"
        },
        dynamic: {
          title: "Dynamic"
        },
        article_features: {
          title: "Article Feature | Article Features"
        },
        include_in_score: {
          title: "Score main category"
        },
        hidden_on_insight: {
          title: "Hidden on Insight"
        },
        affects_score: {
          title: "Include in score",
          description: "Positive and negative mentions against tags from this category will contribute to the score."
        },
        custom_color: {
          title: "Color",
          description: "Category color in the editor UI."
        },
        allow_association: {
          title: "Allow association"
        },
        created_at: {
          title: "Created at"
        }
      },
      types: {
        article_feature: 'Article Feature',
        article_detail: 'Article Detail',
        media_feature: 'Media Feature',
        organization: 'Organization',
        grouping: 'Grouping',
        sources: 'Sources',
        media_tag: 'Media Tag',
      },
      form: {
        create: {
          title: "Add Category",
          save: "Save Category",
        },
        errors: {
          title: "Something went wrong.",
          confirmation_required: "Confirmation required.",
          duplicated: "A category with this name already exists",
          // category_tags_in_use: "1 article | {count} articlesssss",
          category_tags_in_use: "Caution: Changing a category's type will remove all existing tags related to that category from 1 article in the project and will not replace them under the new category type. The category type change will be visible for new articles, but to re-apply tags to old articles under the new category you will need to apply the 'Add Mentions' function. | Caution: Changing a category's type will remove all existing tags related to that category from {count} articles in the project and will not replace them under the new category type. The category type change will be visible for new articles, but to re-apply tags to old articles under the new category you will need to apply the 'Add Mentions' function."
        }
      }
    },
  }
}

module.exports.categories = categories;